module.exports = {
    filter: {
        showFiltersOpen: false,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/filter.js